import { useEffect, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import { getIn } from "formik";
import WeekdayTable from "./WeekdayTable";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import DatePicker from "react-multi-date-picker";

export const SchedulingModalInner = (props) => {
  const {
    index,
    values,
    errors,
    bookingFormvalues,
    handleChange,
    setFieldValue,
    touched,
    selectedData,
    creativeList,
    programData,
    selectedCreativeIds
  } = props;

  const [openCalenderStartModal, setOpenCalenderStartModal] = useState(false);
  const [openCalenderEndModal, setOpenCalenderEndModal] = useState(false);
  const [scheduleData, setScheduleData] = useState([]);

  const fieldPaths = {
    dateType: `scheduleDetails[${index}].type`,
    scheduleType: `scheduleDetails[${index}].scheduleType`,
    startDate: `scheduleDetails[${index}].startDate`,
    endDate: `scheduleDetails[${index}].endDate`,
    creative: `scheduleDetails[${index}].creative`,
    creativeDuration: `scheduleDetails[${index}].creativeDuration`,
    selectedDates: `scheduleDetails[${index}].selectedDates`,
    program: `scheduleDetails[${index}].program`,
    slots: `scheduleDetails[${index}].slots`,
    fromTime: `scheduleDetails[${index}].fromTime`,
    toTime: `scheduleDetails[${index}].toTime`,
    weekDays: `scheduleDetails[${index}].weekDays`,
  };

  const getErrorAndTouched = (field) => ({
    error: getIn(errors, field),
    touched: getIn(touched, field),
  });
  const setWeekDays = (selectedStartDate, selectedEndDate) => {
    if (selectedStartDate && selectedEndDate) {
      var date = PagesIndex.moment(new Date(selectedStartDate));
      var start = PagesIndex.moment(date).startOf("week");
      var endDate = PagesIndex.moment(new Date(selectedEndDate));
      var end = PagesIndex.moment(endDate).endOf("week");
      var weekArray = [];
      while (start <= end) {
        let week = {
          dates: [],
          name: `Week ${weekArray.length + 1}`,
          total: 0,
        };
        for (let k = 0; k < 7; k++) {
          week.dates.push({
            fullDate: start.format("DD-MM-YYYY"),
            date: start.format("DD MMM"),
            value: start.isBetween(date, endDate, null, "[]")
              ? values?.weekDays
                  ?.find(
                    (data) => data?.name === `Week ${weekArray.length + 1}`
                  )
                  ?.dates?.find(
                    (data) => data?.fullDate === start.format("DD-MM-YYYY")
                  )?.value || 0
              : 0,
            disabled: !start.isBetween(date, endDate, null, "[]"),
          });
          start.add(1, "days"); // Move to the next day
        }
        week.total = week.dates.reduce(
          (acc, cur) => acc + parseInt(cur.value || 0),
          0
        );
        weekArray.push(week);
      }
      setFieldValue(fieldPaths.weekDays, weekArray);
    } else {
      setFieldValue(fieldPaths.weekDays, []);
    }
  };

  const setSlotData = (
    selectedStartTime,
    selectedEndTime,
    scheduleDataArg = scheduleData
  ) => {
    const start = PagesIndex.moment(new Date(selectedStartTime)).format(
      "HH:mm"
    );
    const end = PagesIndex.moment(new Date(selectedEndTime)).format("HH:mm");
    const slotData = scheduleDataArg
      ?.filter((item) => {
        const fromTime = PagesIndex.moment(item?.startTime).format("HH:mm");
        const toTime = PagesIndex.moment(item?.endTime).format("HH:mm");
        return (
          fromTime >= start &&
          toTime >= start &&
          fromTime <= end &&
          toTime <= end
        );
      })
      ?.filter((data) => {
        if (values?.type === "dateRange") return data;
        if (values?.type === "date") {
          const dates = values?.selectedDates?.map((val) =>
            PagesIndex.moment(val?.fullDate, "DD-MM-YYYY").format("YYYY-MM-DD")
          );
          return dates?.includes(data?.date);
        }
      })
      .map((option) => option?._id);

    setFieldValue(
      fieldPaths.slots,
      selectedStartTime && selectedEndTime ? slotData : []
    );
  };

  const handleFetchSchedule = () => {
    const urlEncoded = new URLSearchParams({
      scheduleId: selectedData?.schedule,
      startDate: PagesIndex.dayjs(values?.startDate).format("YYYY-MM-DD"),
      endDate: PagesIndex.dayjs(values?.endDate).format("YYYY-MM-DD"),
    });

    PagesIndex.apiPostHandler(PagesIndex.Api.GET_SCHEDULES_DATA, urlEncoded)
      .then((res) => {
        if (res.status === 200) {
          setScheduleData(res?.data);
          if (values?.fromTime && values?.toTime) {
            setSlotData(values?.fromTime, values?.toTime, res?.data);
          }
        } else {
          PagesIndex.toasterError(res?.message);
        }
      })
      .catch((err) =>
        PagesIndex.toasterError(
          err.response?.message || "Error fetching schedule data"
        )
      );
  };

  useEffect(() => {
    if (values?.startDate && values?.endDate) handleFetchSchedule();
  }, [values?.startDate, values?.endDate]);

  return (
    <Index.Box className="order-show-inner-box">
      <Index.Box className="grid-row">
        <Index.Box className="admin-sub-title-main view-order-title-main">
          <Index.Typography className="admin-sub-title">
            Date Type
          </Index.Typography>
        </Index.Box>

        <Index.Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          columnGap={{ xs: 0, sm: 0, md: 0, lg: 0 }}
        >
          <Index.Box
            gridColumn={{
              xs: "span 12",
              sm: "span 6",
              md: "span 8",
              lg: "span 12",
            }}
            className="grid-column"
          >
            <Index.Box className="admin-input-box add-ads-input-main admin-radio-main">
              <Index.RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                id={fieldPaths.dateType}
                name={fieldPaths.dateType}
                className="admin-radiogroup"
                value={values?.type}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue(fieldPaths.startDate, null);
                  setFieldValue(fieldPaths.endDate, null);
                  setFieldValue(fieldPaths.selectedDates, []);
                  setFieldValue(fieldPaths.fromTime, null);
                  setFieldValue(fieldPaths.toTime, null);
                  setFieldValue(fieldPaths.program, undefined);
                  setFieldValue(fieldPaths.weekDays, []);
                }}
              >
                <Index.FormControlLabel
                  value="dateRange"
                  control={<Index.Radio className="admin-radio" />}
                  label="Date Range"
                />
                <Index.FormControlLabel
                  value="date"
                  control={<Index.Radio className="admin-radio" />}
                  label="Dates"
                />
              </Index.RadioGroup>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
      {values?.type === "dateRange" ? (
        <Index.Box className="view-date-slot-main">
          <Index.Box className="grid-row">
            <Index.Box
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              columnGap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
              rowGap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
              className="date-range-row"
            >
              <Index.Box
                gridColumn={{
                  xs: "span 12",
                  sm: "span 6",
                  md: "span 4",
                  lg: "span 4",
                }}
                className="grid-column"
              >
                <Index.Box className="admin-input-box  admin-date-input-main input-spacing-remove">
                  <Index.FormHelperText className="admin-form-lable">
                    <span>Start Date</span>
                    <span className="astrick-sing">*</span>
                  </Index.FormHelperText>
                  <Index.Box className="admin-form-group">
                    <PagesIndex.LocalizationProvider
                      dateAdapter={Index.AdapterDayjs}
                    >
                      <PagesIndex.DatePicker
                        open={openCalenderStartModal}
                        onClose={() => setOpenCalenderStartModal(false)}
                        className="admin-form-control admin-date-picker-control"
                        value={PagesIndex.dayjs(values.startDate)} // Use '01/01/2000' as the default value
                        onChange={(date) => {
                          setFieldValue(fieldPaths.startDate, date);
                          setFieldValue(fieldPaths.endDate, null);
                          setWeekDays(date, null, index);
                          // setFieldValue(fieldPaths.fromTime, null);
                          // setFieldValue(fieldPaths.toTime, null);
                          setFieldValue(fieldPaths.program, undefined);
                          setFieldValue(fieldPaths.slots, []);
                        }}
                        minDate={PagesIndex.dayjs(bookingFormvalues?.startDate)}
                        maxDate={PagesIndex.dayjs(bookingFormvalues?.endDate)}
                        slotProps={{
                          popper: {
                            className: "date-picker-body",
                          },
                          inputAdornment: {
                            onClick: () => setOpenCalenderStartModal(true),
                          },
                          textField: {
                            readOnly: true,
                            onClick: () => setOpenCalenderStartModal(true),
                          },
                          inputAdornment: {
                            onClick: () => setOpenCalenderStartModal(true), // This triggers on the calendar icon
                          },
                        }}
                        format="DD/MM/YYYY"
                      />
                    </PagesIndex.LocalizationProvider>
                    <Index.FormHelperText className="admin-error-text">
                      {getErrorAndTouched(fieldPaths.startDate).error &&
                        getErrorAndTouched(fieldPaths.startDate).touched &&
                        getErrorAndTouched(fieldPaths.startDate).error}
                    </Index.FormHelperText>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box
                gridColumn={{
                  xs: "span 12",
                  sm: "span 6",
                  md: "span 8",
                  lg: "span 4",
                }}
                className="grid-column"
              >
                <Index.Box className="admin-input-box admin-date-input-main input-spacing-remove">
                  <Index.FormHelperText className="admin-form-lable">
                    <span>End Date</span>
                    <span className="astrick-sing">*</span>
                  </Index.FormHelperText>
                  <Index.Box className="admin-form-group">
                    <PagesIndex.LocalizationProvider
                      dateAdapter={Index.AdapterDayjs}
                    >
                      <PagesIndex.DatePicker
                        open={openCalenderEndModal}
                        onClose={() => setOpenCalenderEndModal(false)}
                        className="admin-form-control admin-date-picker-control"
                        value={PagesIndex.dayjs(values.endDate)} // Use '01/01/2000' as the default value
                        onChange={(date) => {
                          setFieldValue(fieldPaths.endDate, date);
                          setWeekDays(values?.startDate, date, index);
                          // setFieldValue(fieldPaths.fromTime, null);
                          // setFieldValue(fieldPaths.toTime, null);
                          setFieldValue(fieldPaths.program, undefined);
                          setFieldValue(fieldPaths.slots, []);
                        }}
                        minDate={
                          values?.startDate
                            ? PagesIndex.dayjs(values?.startDate)
                            : PagesIndex.dayjs(bookingFormvalues?.startDate)
                        }
                        maxDate={PagesIndex.dayjs(bookingFormvalues?.endDate)}
                        slotProps={{
                          popper: {
                            className: "date-picker-body",
                          },
                          inputAdornment: {
                            onClick: () => setOpenCalenderEndModal(true),
                          },
                          textField: {
                            readOnly: true,
                            onClick: () => setOpenCalenderEndModal(true),
                          },
                          inputAdornment: {
                            onClick: () => setOpenCalenderEndModal(true), // This triggers on the calendar icon
                          },
                        }}
                        format="DD/MM/YYYY"
                      />
                    </PagesIndex.LocalizationProvider>
                    <Index.FormHelperText className="admin-error-text">
                      {getErrorAndTouched(fieldPaths.endDate).error &&
                        getErrorAndTouched(fieldPaths.endDate).touched &&
                        getErrorAndTouched(fieldPaths.endDate).error}
                    </Index.FormHelperText>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      ) : (
        <></>
      )}
      {values?.type === "date" ? (
        <Index.Box className="admin-input-box">
          <DatePicker
            className="admin-form-control admin-multi-date-picker-control"
            id={fieldPaths.selectedDates}
            name={fieldPaths.selectedDates}
            value={values?.selectedDates?.map((data) => data?.fullDate)}
            multiple
            placeholder="Select Dates"
            plugins={[<DatePanel />]}
            onChange={(dates) => {
              const formattedDates = dates.map((date) => ({
                fullDate: date.format("DD-MM-YYYY"),
                onlyDate: date.format("DD MMM"),
                day: date.format("dddd"),
                value: 0,
                disabled: false,
              }));
              setFieldValue(fieldPaths.selectedDates, formattedDates);
              setFieldValue(fieldPaths.fromTime, null);
              setFieldValue(fieldPaths.toTime, null);
              setFieldValue(fieldPaths.program, undefined);
            }}
            format={"DD/MM/YYYY"}
            minDate={new Date(bookingFormvalues?.startDate)}
            maxDate={new Date(bookingFormvalues?.endDate)}
          />
          <Index.FormHelperText className="admin-error-text">
            {getErrorAndTouched(fieldPaths.selectedDates).error &&
              getErrorAndTouched(fieldPaths.selectedDates).touched &&
              getErrorAndTouched(fieldPaths.selectedDates).error}
          </Index.FormHelperText>
        </Index.Box>
      ) : (
        <></>
      )}
      <Index.Box className="creative-order-row">
        <Index.Box className="grid-row">
          <Index.Box className="admin-sub-title-main view-order-title-main">
            <Index.Typography className="admin-sub-title">
              Schedule Type
            </Index.Typography>
          </Index.Box>
        </Index.Box>
        <Index.Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          columnGap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
          rowGap={{ xs: 2, sm: 2, md: 0, lg: 0 }}
        >
          <Index.Box
            gridColumn={{
              xs: "span 12",
              sm: "span 12",
              md: "span 12",
              lg: "span 12",
            }}
            className="grid-column"
          >
            <Index.Box className="admin-input-box admin-radio-main input-spacing-remove">
              <Index.RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                id={fieldPaths.scheduleType}
                name={fieldPaths.scheduleType}
                className="admin-radiogroup"
                value={values?.scheduleType}
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue(fieldPaths.fromTime, null);
                  setFieldValue(fieldPaths.toTime, null);
                  setFieldValue(fieldPaths.program, undefined);
                  setFieldValue(fieldPaths.slots, []);
                }}
              >
                <Index.FormControlLabel
                  value="program"
                  control={<Index.Radio className="admin-radio" />}
                  label="Program"
                />
                <Index.FormControlLabel
                  value="timeBand"
                  control={<Index.Radio className="admin-radio" />}
                  label="Timeband"
                />
              </Index.RadioGroup>
            </Index.Box>
          </Index.Box>
          <Index.Box
            gridColumn={{
              xs: "span 12",
              sm: "span 6",
              md: "span 6",
              lg: "span 6",
            }}
            className="grid-column"
          >
            <Index.Box className="admin-input-box view-order-lable-input">
              <Index.FormHelperText className="admin-form-lable">
                Add Creative<span className="astrick-sing">*</span>
              </Index.FormHelperText>
              <Index.Box className="admin-input-box input-complete-box">
                <Index.Box className="admin-form-group">
                  <Index.Autocomplete
                    className="admin-auto-complete-control"
                    options={
                      creativeList?.filter(
                        (creativeData) =>
                          selectedData?.platform ===
                            creativeData?.platformId?.typeName &&
                          selectedData?.elements ===
                            creativeData?.elementId?.name
                      ) || []
                    }
                    id={fieldPaths.creative}
                    // disableCloseOnSelect
                    closeText={""}
                    openText={""}
                    clearText={""}
                    value={
                      values?.creative
                        ? creativeList?.find(
                            (data) => data?._id === values?.creative
                          )
                        : null
                    }
                    onChange={(e, selectedOptions) => {
                      setFieldValue(fieldPaths.creative, selectedOptions?._id);
                      setFieldValue(
                        fieldPaths.creativeDuration,
                        selectedOptions?.duration || 1
                      );
                    }}
                    getOptionLabel={(option) =>
                      option?.duration
                        ? `${option?.code}-${option?.name}-${option?.duration} Sec`
                        : `${option?.code}-${option?.name}`
                    }
                    // getOptionDisabled={(option) => selectedCreativeIds.includes(option?._id)}
                    renderOption={(props, item) => (
                      <li {...props} key={item?._id}>
                        {item?.duration
                          ? `${item?.code}-${item?.name}-${item?.duration} Sec`
                          : `${item?.code}-${item?.name}`}
                      </li>
                    )}
                    renderInput={(params) => (
                      <Index.TextField
                        fullWidth
                        className="admin-form-control"
                        name="creative"
                        {...params}
                        size="small"
                        variant="outlined"
                        placeholder="Select Creative"
                      />
                    )}
                  />{" "}
                  <Index.FormHelperText className="admin-error-text">
                    {getErrorAndTouched(fieldPaths.creative).error &&
                      getErrorAndTouched(fieldPaths.creative).touched &&
                      getErrorAndTouched(fieldPaths.creative).error}
                  </Index.FormHelperText>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
          {values?.scheduleType === "program" ? (
            <Index.Box
              gridColumn={{
                xs: "span 12",
                sm: "span 6",
                md: "span 6",
                lg: "span 6",
              }}
              className="grid-column"
            >
              <Index.Box className="admin-input-box view-order-lable-input">
                <Index.FormHelperText className="admin-form-lable">
                  Program<span className="astrick-sing">*</span>
                </Index.FormHelperText>
                <Index.Box className="admin-input-box admin-modal-input-box input-complete-box">
                  <Index.Box className="admin-form-group">
                    <Index.Autocomplete
                      className="admin-form-control admin-auto-complete-control"
                      options={programData || []}
                      id={fieldPaths.program}
                      closeText={""}
                      openText={""}
                      clearText={""}
                      value={
                        values?.program
                          ? programData?.find(
                              (data) => data?._id === values?.program
                            )
                          : null
                      }
                      onChange={(e, selectedOptions) => {
                        setFieldValue(fieldPaths.program, selectedOptions?._id);
                        const slotData = [];
                        const start = PagesIndex.moment(
                          selectedOptions?.startTime
                        ).format("HH:mm");
                        const end = PagesIndex.moment(
                          selectedOptions?.endTime
                        ).format("HH:mm");
                        scheduleData
                          ?.filter((item) => {
                            const fromTime = PagesIndex.moment(
                              item?.startTime
                            ).format("HH:mm");
                            const toTime = PagesIndex.moment(
                              item?.endTime
                            ).format("HH:mm");
                            return (
                              fromTime >= start &&
                              toTime >= start &&
                              fromTime <= end &&
                              toTime <= end
                            );
                          })
                          ?.filter((data) => {
                            if (values?.type === "dateRange") {
                              return data;
                            }
                            if (values?.type === "date") {
                              const dates = values?.selectedDates?.map(
                                (values) =>
                                  PagesIndex.moment(
                                    values?.fullDate,
                                    "DD-MM-YYYY"
                                  ).format("YYYY-MM-DD")
                              );
                              return dates?.includes(data?.date);
                            }
                          })
                          .map((option) => {
                            slotData.push(option?._id);
                          });
                        setFieldValue(fieldPaths.slots, slotData);
                      }}
                      getOptionLabel={(option) => option?.programName}
                      renderOption={(props, item) => (
                        <li {...props} key={item?._id}>
                          {item?.programName}
                        </li>
                      )}
                      renderInput={(params) => (
                        <Index.TextField
                          fullWidth
                          className="admin-form-control"
                          name="program"
                          {...params}
                          size="small"
                          variant="outlined"
                          placeholder="Select Program"
                        />
                      )}
                    />
                    <Index.FormHelperText className="admin-error-text">
                      {getErrorAndTouched(fieldPaths.program).error &&
                        getErrorAndTouched(fieldPaths.program).touched &&
                        getErrorAndTouched(fieldPaths.program).error}
                    </Index.FormHelperText>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          ) : (
            <></>
          )}

          {values?.scheduleType === "timeBand" ? (
            <Index.Box
              gridColumn={{
                xs: "span 12",
                sm: "span 6",
                md: "span 6",
                lg: "span 6",
              }}
              className="grid-column"
            >
              <Index.Box className="view-date-slot-main">
                <Index.Box className="grid-row">
                  <Index.Box
                    display="grid"
                    gridTemplateColumns="repeat(12, 1fr)"
                    columnGap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                  >
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="admin-input-box admin-modal-input-box admin-date-input-main">
                        <Index.FormHelperText className="admin-form-lable">
                          From Time<span className="astrick-sing">*</span>
                        </Index.FormHelperText>
                        <Index.FormControl
                          className="admin-form-control admin-drop-form-control"
                          // onClick={() => setFromDateOpen(true)}
                        >
                          <Index.Box className="admin-form-group">
                            <PagesIndex.LocalizationProvider
                              dateAdapter={Index.AdapterDayjs}
                            >
                              <PagesIndex.TimePicker
                                views={["hours", "minutes", "seconds"]}
                                timeSteps={{
                                  minutes: 1,
                                  seconds: 1,
                                }}
                                className="admin-form-control admin-date-picker-control"
                                value={PagesIndex.dayjs(values?.fromTime)}
                                onChange={(date) => {
                                  setFieldValue(fieldPaths.fromTime, date);
                                  setFieldValue(fieldPaths.toTime, null);
                                  setSlotData(date, values?.toTime);
                                }}
                                ampm={false}
                                slotProps={{
                                  popper: {
                                    className: "date-picker-body",
                                  },
                                }}
                              />
                            </PagesIndex.LocalizationProvider>
                            <Index.FormHelperText className="admin-error-text">
                              {getErrorAndTouched(fieldPaths.fromTime).error &&
                                getErrorAndTouched(fieldPaths.fromTime)
                                  .touched &&
                                getErrorAndTouched(fieldPaths.fromTime).error}
                            </Index.FormHelperText>
                          </Index.Box>
                        </Index.FormControl>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 6",
                        lg: "span 6",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="admin-input-box admin-modal-input-box admin-date-input-main">
                        <Index.FormHelperText className="admin-form-lable">
                          To Time<span className="astrick-sing">*</span>
                        </Index.FormHelperText>
                        <Index.FormControl className="admin-form-control admin-drop-form-control">
                          <Index.Box className="admin-form-group">
                            <PagesIndex.LocalizationProvider
                              dateAdapter={Index.AdapterDayjs}
                            >
                              <PagesIndex.TimePicker
                                views={["hours", "minutes", "seconds"]}
                                timeSteps={{
                                  minutes: 1,
                                  seconds: 1,
                                }}
                                className="admin-form-control admin-date-picker-control"
                                value={PagesIndex.dayjs(values?.toTime)}
                                minTime={PagesIndex.dayjs(values?.fromTime)}
                                onChange={(date) => {
                                  setFieldValue(fieldPaths.toTime, date);
                                  setSlotData(values?.fromTime, date);
                                }}
                                ampm={false}
                                slotProps={{
                                  popper: {
                                    className: "date-picker-body",
                                  },
                                }}
                              />
                            </PagesIndex.LocalizationProvider>
                            <Index.FormHelperText className="admin-error-text">
                              {getErrorAndTouched(fieldPaths.toTime).error &&
                                getErrorAndTouched(fieldPaths.toTime).touched &&
                                getErrorAndTouched(fieldPaths.toTime).error}
                            </Index.FormHelperText>
                          </Index.Box>
                        </Index.FormControl>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          ) : (
            <></>
          )}
        </Index.Box>
      </Index.Box>

      {values?.type === "dateRange" ? (
        values?.weekDays?.length ? (
          <Index.Box className="week-main">
            <Index.Box className="week-day-name-flex">
              <Index.Typography className="week-day-text"></Index.Typography>
              <Index.Typography className="week-day-text">Sun</Index.Typography>
              <Index.Typography className="week-day-text">Mon</Index.Typography>
              <Index.Typography className="week-day-text">Tue</Index.Typography>
              <Index.Typography className="week-day-text">Wed</Index.Typography>
              <Index.Typography className="week-day-text">Thu</Index.Typography>
              <Index.Typography className="week-day-text">Fri</Index.Typography>
              <Index.Typography className="week-day-text">Sat</Index.Typography>
              <Index.Typography className="week-day-text">
                Total
              </Index.Typography>
              <Index.Typography className="week-day-text">
                Total Seconds
              </Index.Typography>
            </Index.Box>
            {values?.weekDays.map((data, index) => {
              return (
                <WeekdayTable
                  key={index}
                  creativeDuration={values?.creativeDuration}
                  weekArray={values?.weekDays}
                  index={index}
                  data={data}
                  weekDays={fieldPaths.weekDays}
                  setFieldValue={setFieldValue}
                />
              );
            })}
            <Index.Box className="week-box-outer week-box">
              <Index.Typography className="week-date-text">
                Total Creative Seconds:
              </Index.Typography>
              <Index.Box className="week-input-box">
                <Index.Box className="admin-form-group">
                  <Index.TextField
                    fullWidth
                    id="fullWidth"
                    className="admin-form-control"
                    placeholder=""
                    disabled
                    value={values?.weekDays?.reduce(
                      (acc, cur) =>
                        acc + cur.total * (values?.creativeDuration || 1),
                      0
                    )}
                  />
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
      {values?.type === "date" ? (
        values?.selectedDates?.length ? (
          <Index.Box className="week-main">
            <Index.Box className="week-day-name-flex">
              {values?.selectedDates.map((data, index) => {
                return (
                  <Index.Typography className="week-day-text" key={data?.day}>
                    {data?.day}
                  </Index.Typography>
                );
              })}
            </Index.Box>
            <Index.Box className="week-content-main-flex">
              {values?.selectedDates.map((data, index) => {
                return (
                  <Index.Box
                    className="week-box"
                    key={`${data?.day}-${data?.onlyDate}`}
                  >
                    <Index.Typography className="week-date-text">
                      {data?.onlyDate}
                    </Index.Typography>
                    <Index.Box className="admin-input-box week-input-box">
                      <Index.Box className="admin-form-group">
                        <Index.TextField
                          fullWidth
                          id="fullWidth"
                          className="admin-form-control"
                          placeholder={"0"}
                          value={data?.value === 0 ? "" : data?.value}
                          disabled={data?.disabled}
                          inputProps={{ maxLength: 3 }}
                          onChange={(e) => {
                            const regex = /^[0-9]*$/;
                            if (regex.test(e.target.value)) {
                              const updatedData = [...values.selectedDates];
                              updatedData[index].value = e.target.value || 0;
                              setFieldValue("selectedDates", updatedData);
                            }
                          }}
                        />
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                );
              })}
            </Index.Box>
          </Index.Box>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </Index.Box>
  );
};
